import { LazyLoadImage } from 'react-lazy-load-image-component';

import dialogs from '../../dialogs';
import { Title } from '../../utils/title';
import Layout from './Layout';
import styles from './Creator.module.scss';

import hero from './common/hero.module.scss';
import section_a from './common/section_a.module.scss';
import section_b from './common/section_b.module.scss';
import action_a from './common/action_a.module.scss';
import action_b from './common/action_b.module.scss';
import cards from './common/cards.module.scss';

import hero_1 from '../../assets/landing/hero/1.svg';
import hero_2 from '../../assets/landing/hero/2.svg';
import hero_3 from '../../assets/landing/hero/3.gif';

import section_1_lg from '../../assets/landing/section/creator/1_lg.png';
import section_1_sm from '../../assets/landing/section/creator/1_sm.png';
import section_1_svg from '../../assets/landing/section/creator/1_svg.svg';

import section_2_lg from '../../assets/landing/section/creator/2_lg.png';
import section_2_sm from '../../assets/landing/section/creator/2_sm.png';
import section_2_svg from '../../assets/landing/section/creator/2_svg.svg';

import section_3_lg from '../../assets/landing/section/creator/3_lg.png';
import section_3_sm from '../../assets/landing/section/creator/3_sm.png';
import section_3_svg from '../../assets/landing/section/creator/3_svg.svg';

import action_b_creator from '../../assets/landing/action/b_creator.svg';

import icon_compass from '../../assets/landing/icons/compass.svg';
import icon_plus from '../../assets/landing/icons/plus.svg';
import icon_share from '../../assets/landing/icons/share.svg';

const Hero = () => {

  const { setDialog } = dialogs.utils.useDialog();

  return (
    <div className={hero.root}>
      <div className={hero.content}>
        <div className={hero.title}>
          Be heard and
          <br/>
          earn rewards!
        </div>

        <div className={hero.image_1}>
          <LazyLoadImage
            src={hero_1}
            alt='text review'
          />
        </div>

        <div className={hero.image_2}>
          <LazyLoadImage
            src={hero_2}
            alt='convert to'
          />
        </div>

        <div className={hero.image_3}>
          <LazyLoadImage
            src={hero_3}
            alt='video review'
          />
        </div>

        <div className={hero.text}>
          Join our community of creators to share
          your opinions and earn rewards!
        </div>

        <div className={hero.action}>
          <button onClick={() => setDialog('signup')}>
            Sign Up
          </button>
        </div>
      </div>
    </div>
  );
};

const SectionA1 = () => {
  return (
    <div className={section_a.root}>
      <div className={section_a.content}>
        <div className={section_a.image}>
          <LazyLoadImage
            className={section_a.lg}
            src={section_1_lg}
            alt='cosmetics'
          />
          <LazyLoadImage
            className={section_a.sm}
            src={section_1_sm}
            alt='cosmetics'
          />
        </div>

        <div className={section_a.svg}>
          <LazyLoadImage
            src={section_1_svg}
            alt='discover'
          />
        </div>

        <div className={section_a.title}>
          Discover amazing new products...
        </div>

        <div className={section_a.text}>
          Join our Creator Community to access the world’s best brands. Free and
          discounted items are delivered directly to your door so you can test
          and fall in love with brands one by one!
        </div>
      </div>
    </div>
  );
};

const SectionB = () => {
  return (
    <div className={section_b.root}>
      <div className={section_b.content}>
        <div className={section_b.image}>
          <LazyLoadImage
            className={section_b.lg}
            src={section_2_lg}
            alt='man using a mobile device'
          />
          <LazyLoadImage
            className={section_b.sm}
            src={section_2_sm}
            alt='man using a mobile device'
          />
        </div>

        <div className={section_b.svg}>
          <LazyLoadImage
            src={section_2_svg}
            alt='share'
          />
        </div>

        <div className={section_b.title}>
          Share your opinion...
        </div>

        <div className={section_b.text}>
          After testing a product, simply write a review via our platform or
          the brand's website. Chime in with your thoughts, spread the word and
          help other consumers just like you to discover brands they will love.
        </div>
      </div>
    </div>
  );
};

const SectionA2 = () => {
  return (
    <div className={section_a.root}>
      <div className={section_a.content}>
        <div className={section_a.image}>
          <LazyLoadImage
            className={section_a.lg}
            src={section_3_lg}
            alt='woman using a mobile device'
          />
          <LazyLoadImage
            className={section_a.sm}
            src={section_3_sm}
            alt='woman using a mobile device'
          />
        </div>

        <div className={section_a.svg}>
          <LazyLoadImage
            src={section_3_svg}
            alt='network'
          />
        </div>

        <div className={section_a.title}>
          Stand out and be heard
        </div>

        <div className={section_a.text}>
          This is where the magic happens! Written reviews are automagically
          converted to engaging video content ready to share with the world
          via popular social media networks like TikTok, Instagram, Twitter
          and Facebook. View, edit, customise and share.
        </div>
      </div>
    </div>
  );
};

const ActionA = () => {

  const { setDialog } = dialogs.utils.useDialog();

  return (
    <div className={action_a.root}>
      <div className={action_a.content}>
        <div className={action_a.title}>
          Reviews worth sharing
        </div>

        <div className={action_a.text}>
          Discover new products, share your opinions and
          let your voice be heard!
        </div>

        <div className={action_a.action}>
          <button onClick={() => setDialog('signup')}>
            Sign Up
          </button>
        </div>
      </div>
    </div>
  );
};

const ActionB = () => {

  const { setDialog } = dialogs.utils.useDialog();

  return (
    <div className={action_b.root}>
      <div className={action_b.content}>
        <div className={action_b.title}>
          Discover free products today...
        </div>

        <div className={action_b.action}>
          <button onClick={() => setDialog('signup')}>
            Let's Go!
          </button>
        </div>

        <div className={action_b.image}>
          <LazyLoadImage
            src={action_b_creator}
            alt='discover'
          />
        </div>
      </div>
    </div>
  );
};

const Cards = () => {
  return (
    <div className={cards.root}>
      <div className={cards.title}>
        Why Chimeable?
      </div>

      <div className={`${cards.content} ${cards.col_3}`}>
        <div className={cards.card}>
          <div className={cards.image}>
            <LazyLoadImage
              src={icon_compass}
              alt='compass'
            />
          </div>

          <div className={cards.title}>
            Discover New Products
          </div>

          <div className={cards.text}>
            Get free and discounted items delivered to your door.
          </div>
        </div>

        <div className={cards.card}>
          <div className={cards.image}>
            <LazyLoadImage
              src={icon_plus}
              alt='plus'
            />
          </div>

          <div className={cards.title}>
            Create a Following
          </div>

          <div className={cards.text}>
            Share your opinions and find fame with your reviews.
          </div>
        </div>

        <div className={cards.card}>
          <div className={cards.image}>
            <LazyLoadImage
              src={icon_share}
              alt='share'
            />
          </div>

          <div className={cards.title}>
            Help Fellow Consumers
          </div>

          <div className={cards.text}>
            Share your reviews and help consumers to discover new brands.
          </div>
        </div>
      </div>
    </div>
  );
};

const Creator = () => {
  return (
    <>
      <Title value='Creators'/>
      <Layout>
        <div className={styles.root}>
          <Hero />
          <SectionA1 />
          <SectionB />
          <SectionA2 />
          <ActionA />
          <Cards />
          <ActionB />
        </div>
      </Layout>
    </>
  );
};

export default Creator;